export async function redirectToSamsungLoginPage({
  memberInfoData,
  accessToken,
  index,
  id,
}) {
  let currentState = `${accessToken}|`;
  if (id) currentState = `${accessToken}|${id}`;

  try {
    const sal = await samsungaccount.SamsungAccountClient.createSamsungAccountClient(
      {
        // clientId: "l7clvyrrhs",
        clientId: "85lpzisaun",
      }
    );
    await sal.signInRedirect({
   //   redirectUri: `https://hkclubs.local.opentide.com.cn/ClubsAPI/SSORedirect/${index}`,
       redirectUri: `https://hkclubs.samsung.com/ClubsAPI/SSORedirect/${index}`,
      responseType: "code",
      state: memberInfoData ? currentState : `|${id}`,
    });
    console.log(memberInfoData);
    console.log(url);
  } catch (error) {
    console.error("Samsung login error:", error);
  }
}
